import { render, staticRenderFns } from "./splitReturnedAmount.vue?vue&type=template&id=2ba0bb70&scoped=true&"
import script from "./splitReturnedAmount.vue?vue&type=script&lang=js&"
export * from "./splitReturnedAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0bb70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba0bb70')) {
      api.createRecord('2ba0bb70', component.options)
    } else {
      api.reload('2ba0bb70', component.options)
    }
    module.hot.accept("./splitReturnedAmount.vue?vue&type=template&id=2ba0bb70&scoped=true&", function () {
      api.rerender('2ba0bb70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/components/splitReturnedAmount.vue"
export default component.exports